import { FormsService } from "./../../../services/forms/forms.service";
import { put } from "@redux-saga/core/effects";

import { undo } from "./../../../helpers/undoable";
import { ChangeIsPaginationActiveRequestActionType } from "./../types";

export function* updateIsPaginationActiveSaga(action: ChangeIsPaginationActiveRequestActionType) {
    const {
        payload: { isPaginationActive },
    } = action;

    try {
        yield FormsService.updateFormComponent({ data: [{ isPaginationActive }] });
    } catch (error) {
        yield put(undo(action));
    }
}
